import React from 'react';
import './st_grid_component_style.scss';

class SpaceTagGridSlot extends React.Component {
  render() {
    let value = this.props.value;
    return(
      <div className={'st_grid'}>
        <div className={'st_grid_box'}>
          <h5>{value}</h5>
        </div>
      </div>
    )
  }
}

export default SpaceTagGridSlot;
